import { ChatMessage, ClientChatMessage } from '../../models/chatMessage';
import { ChatSession } from '../../models/chatSession';
import { ChatStorageManager } from '../ChatStorageManager';

export class DefaultChatStorageManager implements ChatStorageManager {
  async getSessions(): Promise<ChatSession[] | null> {
    return null;
  }

  async saveSessions(): Promise<void> {}

  async clearSessions(): Promise<void> {}

  async getPendingMessages(): Promise<ClientChatMessage[]> {
    return [];
  }

  async savePendingMessages(): Promise<void> {}

  async clearPendingMessages(): Promise<void> {}

  async getMessages(): Promise<ChatMessage[]> {
    return [];
  }

  async saveMessages(): Promise<void> {}

  async clearMessages(): Promise<void> {}
}
